// GLSL shader（由 .glsl 迁移为 TS 模块）
export default /* glsl */ `// ============================================================
// GSplat Covariance - 由旋转矩阵和缩放向量计算协方差
// ============================================================

void computeCovariance(in mat3 rot, in vec3 scale, out vec3 covA, out vec3 covB) {
  vec3 modifiedScale = scale;
  #ifdef GSPLAT_SHADER_EFFECT_VIEW_GUARD
    if (gsplatShaderEffectEnabled) {
      modifySplatScale(modifiedScale);
    }
  #else
    modifySplatScale(modifiedScale);
  #endif

  mat3 M = transpose(mat3(
    modifiedScale.x * rot[0],
    modifiedScale.y * rot[1],
    modifiedScale.z * rot[2]
  ));

  covA = vec3(dot(M[0], M[0]), dot(M[0], M[1]), dot(M[0], M[2]));
  covB = vec3(dot(M[1], M[1]), dot(M[1], M[2]), dot(M[2], M[2]));
}
`;
